import { render, staticRenderFns } from "./SpeechSettingsTab.vue?vue&type=template&id=51f8712a&scoped=true"
import script from "./SpeechSettingsTab.vue?vue&type=script&lang=js"
export * from "./SpeechSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SpeechSettingsTab.vue?vue&type=style&index=0&id=51f8712a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8712a",
  null
  
)

export default component.exports